import React, { useState } from 'react'
import AddNewTobaccoUse from './AddNewTobaccoUse';

const TobaccoUse = ({ data, setIsRecordSaved, patientID, ...props }) => {
  
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenTobaccoUse, setIsOpenTobaccoUse] = useState(false);
  // const [tobaccoUseID, setTobaccoUseID] = useState();
  const [tobaccoUseData, setTobaccoUseData] = useState([]);
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const handleAddTobacco = (item) => {
    if(item.EffectiveDate) return;
    AddTobaccoUse(item);
  }

  const AddTobaccoUse = (item) => {
    if(!isViewAllowed) return;
    setTobaccoUseData(item)
    setIsOpenTobaccoUse(prev => !prev);
  }
  const CloseTobaccoUse = () => {
    setIsOpenTobaccoUse(false)
  }

  let PopupScreen = "";
  if (isOpenTobaccoUse) {
    PopupScreen = <AddNewTobaccoUse isOpenTobaccoUse={isOpenTobaccoUse} tobaccoUseData={tobaccoUseData} setIsRecordSaved={setIsRecordSaved} onClose={CloseTobaccoUse} patientID={patientID}// onDeleteTobaccoUse={DeleteTobaccoUse}
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} 
    />
  }
  return (
    <div className='mb-2 px-2'>
      {PopupScreen}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Tobacco Use</p>
        {data?.length === 0 ? 
        <div className={`ar-add-icon  ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddTobaccoUse({ PatientHistoryID: null })}>
          <i className="icon-dash-plus"></i>
        </div> : <></>}
      </div>
      <div className="d-flex flex-column gap-1">
        {expandItems &&
          (data?.length > 0 ?
          data.map(item => (
            <div className="">
              <p className={`text validate-color cursor-pointer font-m ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddTobaccoUse(item)}>{item.EffectiveDate}</p>
              <p className={`px-1 text bg_light validation_message text-nowrap mt-1 ${!(item.EffectiveDate) ? 'ar-hover-text' : ''}`} onClick={() => handleAddTobacco(item)}>{item.TobaccoUse}</p>
            </div>
          )) :
          <p className="text C9-light-clr fst-italic">No tobacco use recorded</p>)}
      </div>
    </div>
  )
}

export default TobaccoUse